export default "__VITE_ASSET__CIq2dfLu__"